import { IOutputChannelStateFactory } from '@/apps/timeSeriesViewer';

export class FileState {}

export class FileStateFactory implements IOutputChannelStateFactory {
  create(): FileState {
    return new FileState();
  }
}
